import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { config } from '../../../../config/config';
import { CgpApiService } from '../../../../modules/cgp-api';

@Injectable()
export class ViewUpdateTprService {

}
